// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__22PCn","filesListContainer":"PosDisputesFiles_filesListContainer__c9jwO","filesButton":"PosDisputesFiles_filesButton__eT55d"};